import { AuthClient, createAuthClient } from '@meteor/app-core-api/id-client';

export let authClient = createAuthClient({
  host: import.meta.env.VITE_APP_ID_API_HOST!
});

export type IAuthIntent = Awaited<ReturnType<AuthClient['authIntent']['get']>>;
